import type { ReactNode } from 'react';
import { Box } from '@mui/material';

export interface LibraryCardKickerProps {
  icon?: ReactNode;
  children: ReactNode;
}

/**
 * The kind/category eyebrow above a block card's title (Figma `bl.library.default`, node
 * `6:3`). Template cards carry no kicker (design ruling 2026-09-07).
 */
export function LibraryCardKicker({ icon, children }: LibraryCardKickerProps) {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 'var(--size-4)',
        color: 'var(--text-body)',
        fontSize: 'var(--font-label-large-size, 0.875rem)',
        fontWeight: 'var(--font-weight-medium, 500)'
      }}
    >
      {icon ? (
        <Box aria-hidden component="span" sx={{ display: 'inline-flex', color: 'var(--icon-neutral)', fontSize: 'var(--size-16)' }}>
          {icon}
        </Box>
      ) : null}
      {children}
    </Box>
  );
}
